import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input,
  viewChild,
} from '@angular/core';
import { PanZoomComponent } from 'ngx-panzoom';
import { Subscription } from 'rxjs';
import { DetailImage } from 'src/app/modules/pim-graphql/views/detail-view/detail-image-view/detail-image.model';

@Component({
  selector: 'app-image-fullscreen',
  templateUrl: './image-fullscreen.component.html',
  styleUrls: ['./image-fullscreen.component.scss'],
  standalone: false,
})
export class ImageFullscreenComponent implements OnInit, OnDestroy {
  @Input() image?: DetailImage;
  @Input() enableControls: boolean = false;
  @Output() fSClose = new EventEmitter();
  @Output() fSNext = new EventEmitter();
  @Output() fSPrev = new EventEmitter();

  readonly panZoom = viewChild(PanZoomComponent);
  private apiSubscription: Subscription | undefined;

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';
  }

  closeFullscreen() {
    this.fSClose.emit();
  }

  ngOnDestroy(): void {
    document.body.style.overflow = 'auto';
    if (this.apiSubscription) this.apiSubscription.unsubscribe();
  }

  onLoad() {
    this.panZoom()?.resetView();
  }
}
